import React, { Component } from 'react';
import Header from '../../Header';
import MessageLink from '../../MessageLink';
import Footer from '../../Footer';
import PageDescription from '../../PageDescription';
import BannerSingle from '../../BannerSingle';
import Lgpd from '../../Lgpd';
import ErrorBoundary from '../../ErrorHandler/ErrorBoundary';
class LGPD extends Component {
	render() {
		return (
			<div>
				{/* HEADER */}{/* LOGIN */}
				<ErrorBoundary><Header /></ErrorBoundary>
				<main>
					<ErrorBoundary><BannerSingle image={"lgpd"} page={'lgpd'} /></ErrorBoundary>
					{/* Page description */}
					<ErrorBoundary><PageDescription page={'lgpd'} /></ErrorBoundary>
					{/* Content page */}
					{/* <section className="_the-content pb-10">
						<div className='container'>
							<div className="row justify-content-center">
								<div className="col-lg-10">
									<h3> Saiba como a Forluz está tratando os seus dados pessoais </h3>
									<br />
									<h3> Importância do Cadastro </h3>
									<p>
										Para entidades como a Forluz, dados pessoais de seus participantes são informações essenciais para o exercício de suas atividades e cumprimento de seu objetivo de assegurar os benefícios previstos nos regulamentos dos planos previdenciários aos participantes e beneficiários.

										<br /><br />
										O cadastro é, portanto, a base de dados mais valiosa e impactante da Fundação, compreendendo informações de participantes, beneficiários e seus respectivos dependentes, assim como, em volume menos expressivo, de outras pessoas naturais com quem a Entidade se relaciona.
										<br /><br />
										Tratar todos esses dados, com segurança e sob sigilo, sempre foi uma preocupação da Forluz e, com a Lei Geral de Proteção de Dados - LGPD ( <a href="http://www.planalto.gov.br/ccivil_03/_ato2015-2018/2018/lei/l13709.htm">http://www.planalto.gov.br/ccivil_03/_ato2015-2018/2018/lei/l13709.htm</a>), os cuidados passaram a ser reforçados. Descubra o que já foi feito e as iniciativas que serão implementadas para garantir a proteção deste Cadastro.
									</p>
									<br /> <br />
									<h3> Mapeamento do tráfego dos dados</h3>
									<p>
									Durante quatro meses, representantes de todas as áreas da Forluz estiveram envolvidos no trabalho de mapear o tráfego de todos os dados pessoais e dados pessoais sensíveis tratadas em suas respectivas áreas. Ao final deste período, chegamos a um número de 332 atividades mapeadas das mais diversas naturezas.
									<br /><br />
									Esta etapa foi fundamental para assegurar a implantação dos mecanismos de proteção dos dados exigidos pela Lei. Afinal, era necessário identificar o que já era praticado e onde havia necessidade de ajuste. O resultado do levantamento foi avaliado por empresa externa de advocacia, especializada no segmento, que validou o trabalho desenvolvido pela equipe interna.
									<br /><br />
									Como era de se esperar, mais da metade das tarefas envolvendo tratamento de dados na Forluz, diz respeito à hipótese prevista no inciso V do artigo 7º da LGPD, in verbis: “V - quando necessário para a execução de contrato ou de procedimentos preliminares relacionados a contrato do qual seja parte o titular, a pedido do titular dos dados”. Ou seja: grande parte das atividades são essenciais para o cumprimento do contrato previdenciário estabelecido entre a Entidade e seus participantes. Já o cumprimento de obrigação legal ou regulatória, hipótese prevista no inciso II do artigo 7º da LGPD, fundamenta quase 1/4 das tarefas envolvendo tratamento de dados pessoais na Fundação, seguida: (i) legítimo interesse, hipótese prevista no inciso IX; (ii) de exercício regular de direitos em processo judicial, hipótese prevista no inciso VI; e de proteção do crédito, hipótese prevista no inciso X. 
									<br /><br />
									Vale destacar que não foi identificada a necessidade de consentimento formal do titular de dados pessoais nas tarefas executadas pela Forluz envolvendo dados pessoais.


									</p>
									<br /> <br />

									<h3> Segurança da Informação  </h3>
									<p>
									Os arquivos com os dados pessoais são armazenados em ambiente com acesso restrito aos colaboradores responsáveis pela tarefa, conforme solicitação do setor. 
									<br /> <br />
As informações da Forluz são hospedadas em empresa especializada em MSP (Managed Service Provider) – com certificação TIER III – e com os seguintes principais protocolos de segurança para garantia do sigilo e da segurança dos dados pessoais em questão: segurança Endpoint, Firewall gerenciado, backup estruturado, controle de acesso de funcionários a ferramentas de backup e área de armazenamento de servidores, ferramentas IPS (prevenção de intrusão), ferramentas IDS (detecção de intrusão), isolamento de redes por VLAN e Centro de Operações de Segurança (SOC). 
<br /> <br />
Mesmo já possuindo todos estes dispositivos de proteção, a Fundação tomou uma série de medidas com o intuito de cumprir os dispositivos da LGPD e garantir os direitos dos titulares dos dados pessoais por ela tratados, abordadas no tópico a seguir.
Ações realizadas 
<br /> <br />
Primeiramente, vale destacar alguns fatores positivos relacionados com a Governança de entidades fechadas de previdência complementar e, mais especificamente com a Forluz, que criam um ambiente favorável à aderência dessas entidades aos requisitos da LGPD:


									</p>

									<ul>
										<li>obediência a dispositivos legais, de governança, controles internos, compliance e riscos;</li>

										<li>existência de órgão regulador e fiscalizador, com supervisão baseada em riscos;</li>

										<li>exigência de auditoria independente, conselho fiscal e comitê de auditoria;</li>

										<li>previsão de auditoria realizada pelas patrocinadoras;</li>

										<li>adoção de política de segurança de informação;</li>

										<li>adoção de plano de continuidade de negócios;</li>

										<li>matriz de riscos e controles internos; e</li>

										<li>certificação NBR ISO 31000:2018.</li>
									</ul>

									<br /> <br />

									<h3> Ações próprias da Entidade para adequação à LGPD: </h3>
									<ul>
										<li>criação de Grupo de Trabalho específico para mapeamento;</li>

										<li>realização de mapeamento de dados pessoais;</li>

										<li>contratação de assessoria jurídica para avaliação dos dados mapeados;</li>

										<li>reportes periódicos à Alta Administração;</li>

										<li>elaboração e aprovação de Política de Tratamento de Dados Pessoais;</li>

										<li>alteração no Código de Conduta e Ética;</li>

										<li>ações de conscientização e treinamento das equipes; e</li>

										<li>levantamento de todos os riscos relacionados com a LGPD.</li>
									</ul>

									<br /> <br />

									<h3> Equipe capacitada </h3>
									<p>
										Todos os dirigentes, empregados, estagiários e trabalhadores terceirizados foram capacitados com relação às disposições da LGPD e são constantemente submetidos a informações voltadas para a plena consciência do que fazer e de quais são as consequências dos tratamentos de dados pessoais que executam.
									</p>

									<br /> <br />

									<h3> Normativos internos </h3>
									<p>
										A Política de Segurança da Informação da Forluz apresenta um capítulo específico relacionado com o Tratamento de Dados Pessoais, em conformidade com as exigências da LGPD.
										<br /> <br />
										O <a href="https://www.forluz.org.br/Governanca/CodigoCondutaEtica.aspx" target="_blank" > Regulamento de Conduta e Ética da Forluz </a>  sofreu adaptação para abordar as responsabilidades decorrentes da publicação da LGPD
										<br /> <br />
										O Relatório de Impacto à Proteção de Dados Pessoais da Forluz completa os três principais documentos normativos da entidade no que diz respeito à referida Lei.
									</p>
									<br /> <br />
									<h3> Direitos dos Titulares </h3>
									<p>
									Vide artigo 18 da Lei Geral de Proteção de Dados - LGPD (<a href='http://www.planalto.gov.br/ccivil_03/_ato2015-2018/2018/lei/l13709.htm'>http://www.planalto.gov.br/ccivil_03/_ato2015-2018/2018/lei/l13709.htm  </a>).
									</p>

									<br /> <br />
									<h3> Dados do Controlador </h3>
									<p>
									Fundação Forluminas de Seguridade Social - FORLUZ, CNPJ nº 16.539.926/0001-90, com sede na Av. do Contorno, 6.500 – 3º andar, Belo Horizonte – MG - www.forluz.org.br e (31) 3215-6700.
									</p>

									<br /> <br />

									<h3> Fale com o DPO </h3>
									<p> Caso precise de informações sobre a LGPD, tenha sugestões ou críticas fale com o encarregado – Data Protection Officer – DPO através do e-mail  <a href="mailto:dpo@forluz.org.br" target="_blank" rel="noopener noreferrer" data-auth="NotApplicable"  >dpo@forluz.org.br</a> </p>

								</div>
							</div>
						</div>
					</section> */}
				</main>
				{/* FOOTER */}
				<ErrorBoundary><Footer /></ErrorBoundary>
				{/* Message Link */}
				<ErrorBoundary><MessageLink /></ErrorBoundary>
				{/* LGPD */}
				<ErrorBoundary><Lgpd /></ErrorBoundary>
			</div>
		);
	}
};

export default LGPD;